import { React, useState } from 'react';
import { Grid, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { Add, SettingsApplications } from '@mui/icons-material';
import '../../App.css'
import CTCconfigurationTable from '../table-data/CTCconfigurationTable';
import AddNewAllowanceForm from './AddNewAllowanceForm'
import Popup from '../Popup';

function CTC_Configuration() {

  const [openPopup, setOpenPopup] = useState(false);

  const convertToDefEventPara = (name, value) => ({
    target: {
      name: name,
      value: value
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault();
  }

  const handleCloseModal = () => {
    setOpenPopup(false);
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", margin: "10px", padding: "50px", fontWeight: "500px" }}>
      <Paper elevation={5} sx={{ width: "800px" }}>
        <Grid className="form-title" style={{ marginBottom: "-60px" }} container spacing={2}>
          <Grid item> <Typography variant="h5" sx={{ textAlign: "center", margin: 5 }}>CTC Configure</Typography> </Grid>
          <Grid item> <SettingsApplications style={{ marginLeft: "-50px" }} sx={{ width: 45, height: 45 }} /> </Grid>
        </Grid>
        <form autoComplete="off" onSubmit={handleSubmit}>
          <Stack spacing={2} sx={{ margin: "33px" }}>

            <Stack display="flex" sx={{ alignItems: "flex-end",marginRight: "30px" }}>
              <Button
                style={{ width: "200px" }}
                className="form-btn"
                variant="outlined"
                color="success"
                onClick={() => setOpenPopup(true)}
                startIcon={<Add sx={{ width: "24px", height: "24px" }} />} // Use a reasonable size here
                sx={{
                  whiteSpace: "nowrap",
                  textTransform: "none"
                }}
              >
                Add CTC Configuration
              </Button>
            </Stack>

            <CTCconfigurationTable />

          </Stack>
        </form>

        <Popup
          title="Add New Allowance"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}

        >
          <AddNewAllowanceForm onCloseModal={handleCloseModal} />
        </Popup>

      </Paper>
    </Box>
  )
}

export default CTC_Configuration;
